import React, {useEffect, useState} from 'react';
import { Button, Typography } from '@material-ui/core';
import { PaymentErrorStyles } from './PymentErrorStyles';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import Utils from '../../helpers/Utils';
import {checkPaymentFailedStatus, getUserReactivationLink} from "../../api/tenantApi";
import {STRIPE_BILLING_AGENCY, TRUE_STRING} from "../../helpers/CoreConstant";
import {checkCookie} from "../../helpers/Cookie";
import Loading from "../common/Loading";

const PaymentError = ({agencyLogo}) => {
  const classes = PaymentErrorStyles();
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    if (checkCookie(process.env.REACT_APP_ACCESS_TOKEN)) {
      const agencyId = Utils.getAccountData('agencyId');
      const paymentFailed = Utils.getAccountData('payment_failed');

      if (STRIPE_BILLING_AGENCY.includes(agencyId) && paymentFailed) {
        checkPaymentFailedStatusInit();
      }
    }
  }, []);

  const handleRedirect = async () => {
    let redirectLink = '/user/packages';

    if (Utils.getAccountData('stripe_billing') && Utils.getAccountData('stripe_billing') === TRUE_STRING){
      redirectLink = '/user/billing/packages';
    }

    try{
      setLoading(true);

      const resp = await getUserReactivationLink();

      if (resp && resp.success){
        if (resp.data.reactivation_link){
          window.location.href = resp.data.reactivation_link;
          return;
        }
      }

      Utils.updateCookieData("payment_failed", false);
      history.push(redirectLink);
    }catch (err){
      console.log(err);
      Utils.updateCookieData("payment_failed", false);
      history.push(redirectLink);
    }

    setLoading(false);
  };

  const checkPaymentFailedStatusInit = async () => {
    try{
      const resp = await checkPaymentFailedStatus();

      if (resp?.success && resp?.data){
        if (resp.data.payment_failed === false){
          Utils.updateCookieData("payment_failed", resp.data.payment_failed);
          Utils.updateCookieData("standardPack", resp.data.standardPack);
          Utils.updateCookieData("starterPack", resp.data.starterPack);
          Utils.updateCookieData("starterProPack", resp.data.starterProPack);

          setTimeout(()=>{
            window.location.reload();
          }, 500);
        }else {
          setChecking(false);
        }
      }else {
        setChecking(false);
      }
    }catch (err){
      console.log(err);
      setChecking(false);
    }
  };

  if (checking){
    return (
        <div className={classes.root} style={{ justifyContent: 'center' }}>
          <Loading />
        </div>);
  }

  return (
    <div className={classes.root}>
      <div className={classes.header}>
        <img src={agencyLogo} alt="Logo" className={classes.logo} />
      </div>

      <div className={classes.cardContainer}>
        <div className={classes.card}>
          <div className={classes.iconContainer}>

            <img 
              src={`${process.env.REACT_APP_CDN_LINK}assets/images/releases/1.0.0/error_4053013.png`}
              alt="Logo" 
              style={{width:'100%',height:'100%', objectFit: 'contain'}} 
            />
          </div>
          <Typography className={classes.message}>
            There was a problem processing your payment. Please make a payment now to reactivate your account.
          </Typography>

          <Button onClick={handleRedirect} variant="contained" className={classes.button} disabled={loading}>
            Reactivate Account
          </Button>
        </div>

        <div style={{ marginTop: '16px', textAlign: 'center' }}>
          <Typography className={classes.footer}>
            Questions? Contact us via live chat or email us at info@meetpluto.io
          </Typography>
        </div>
      </div>
    </div>
  );
};

export default PaymentError;